export default __webpack_public_path__ + "static/media/chinmoy.babb04f4.png";